/**
 * API base. Empty by default so every call is same-origin `/api/*`.
 *
 * In production Caddy serves this bundle and routes /api to the Python service in the same
 * container; in development Vite proxies /api to it. Either way the browser only ever talks to one
 * origin, so there is no CORS configuration and no BFF proxy — the Next.js route handler that used
 * to inject a bearer is gone along with the private C# API it existed to hide.
 */
export const API_BASE = import.meta.env["VITE_API_BASE"] ?? "";

/**
 * The Windows tray agent's localhost API.
 *
 * **Defaulted, not configured.** The agent binds `127.0.0.1:8780` on every machine it runs on
 * (`Nihongonator.Host/appsettings.json`, `Server.Port`), so this is a constant, not an environment
 * secret — and treating it as one is what broke captures. It used to come from a build-time Vite
 * variable that the old Next.js Railway service happened to have set and `server/Dockerfile` does
 * not, which silently disabled the capture bridge in production: every capture opened a new tab
 * instead of appending to the one already open.
 *
 * Whether an agent is *there* is decided by whether anything answers — see `useAgentBridge` — not
 * by a build flag, so a browser with no agent behind it still behaves correctly. Override with a
 * whole base URL (not a bare port) only if the agent's `Server.Port` was changed.
 * `http://127.0.0.1` is a potentially-trustworthy origin, so an HTTPS page may talk to it; see
 * web/README.md for the mixed-content caveat.
 */
export const DEFAULT_LOCAL_AGENT_URL = "http://127.0.0.1:8780";

/**
 * `||`, not `??`, and that distinction is the bug: `??` keeps an empty string, and an empty string
 * is exactly what `useAgentBridge` treats as "no bridge". A platform that declares the variable
 * without a value (Railway hands those over as `""`) would otherwise re-break captures in the same
 * silent way. Unlike `API_BASE`, empty is never a meaningful value here.
 */
export const LOCAL_AGENT_URL: string =
  import.meta.env["VITE_LOCAL_AGENT_URL"] || DEFAULT_LOCAL_AGENT_URL;
